const API = process.env.REACT_APP_BACKEND_URL;

async function rawRequest(path, options = {}) {
    return fetch(`${API}/api${path}`, { credentials: "include", ...options });
}

async function request(path, options = {}, retried = false) {
    const res = await rawRequest(path, options);
    if (res.status === 401 && !retried && !path.startsWith("/auth/")) {
        const refresh = await rawRequest("/auth/refresh", { method: "POST" });
        if (refresh.ok) return request(path, options, true);
    }
    if (!res.ok) {
        let msg = "Erreur serveur, réessayez";
        try {
            const data = await res.json();
            if (typeof data.detail === "string") msg = data.detail;
        } catch { /* réponse non JSON */ }
        const err = new Error(msg);
        err.status = res.status;
        throw err;
    }
    return res.json();
}

const json = (method, body) => ({
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
});

export const api = {
    me: () => request("/auth/me"),
    login: (email, password) => request("/auth/login", json("POST", { email, password })),
    logout: () => request("/auth/logout", { method: "POST" }),
    listDevis: () => request("/admin/devis"),
    getDevis: (id) => request(`/admin/devis/${id}`),
    createDevis: (body) => request("/admin/devis", json("POST", body)),
    updateDevis: (id, body) => request(`/admin/devis/${id}`, json("PUT", body)),
    signDevis: (id, body) => request(`/admin/devis/${id}/sign`, json("POST", body)),
    completeDevis: (id, body) => request(`/admin/devis/${id}/complete`, json("POST", body)),
    uploadPhotos: (id, files) => {
        const fd = new FormData();
        Array.from(files).forEach((f) => fd.append("files", f));
        return request(`/admin/devis/${id}/photos`, { method: "POST", body: fd });
    },
    deleteDevis: (id) => request(`/admin/devis/${id}`, { method: "DELETE" }),
    pdfUrl: (id, doc) => `${API}/api/admin/devis/${id}/pdf?doc=${doc}`,
};
